const mutations = {
  SET_GROWTH_10K(state, payload) {
    const growthDate = payload.growth && payload.growth.maxMountainChartDate;
    const growthChart = payload.growthChart;
    const growthLargeChart = payload.growthLargeChart;
    const highLowDate = payload.highLow && payload.highLow.dailyPricingAsOfDate;
    const highLowChart = payload.highAndLowPricesChart;

    state.growth10kData = {
      growthDate,
      growthChart,
      growthLargeChart,
      highLowDate,
      highLowChart
    };
  }
};

const getters = {
  growth10kData: state => state.growth10kData
};

const state = {
  growth10kData: null
};

export default {
  state,
  mutations,
  getters
};
